module.exports = __webpack_public_path__ + "static/media/gb-sct.0f43ea47.jpeg";